import axios from "axios";

// export const baseUrl="http://localhost:6071/";
// export const baseUrl="https://kidsdal.com/";
export const baseUrl="/";

export const getImagesApi=async()=>{
    const response=await axios.get(`${baseUrl}api/v1/get-images`);
    return response;
}

export const getVideosApi=async()=>{
    const response=await axios.get(`${baseUrl}api/v1/get-videos`);
    return response;
}